import { Component, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.less'],
})
export class IndexComponent implements OnInit {
  // carousel images
  carouselList: any[] = []
  canUsePortal: boolean = false;
  hasBindCustomer: boolean = false;
  effect: string = 'scrollx';

  // TO DO暂时使用，上生产需要去掉
  isHomeBak: boolean = false;
  carouselImageWH: any = {
    width: `100%`,
    height: `500px`
  }

  pagination = {
    total: 50,
    pageIndex: 1,
    pageSize: 20,
  };
  params = {
    title: '',
    description: '',
    status: 1,
    salesOrg: []
  };

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.carouselImageWH = this.carouselImageStyle()
  }

  constructor(
    public loginService: LoginService,
    private sanitizer: DomSanitizer,
      private route: ActivatedRoute,
  ) { }

  // component init
  ngOnInit(): void {
    localStorage.removeItem('isLogout');
    this.carouselImageWH = this.carouselImageStyle()
    this.getList()
     // 登录成功，跳转到delear portal
    this.loginService.userData$.subscribe((userData: any) => {
      this.route.params.subscribe((params: any) => {
        this.isHomeBak = params?.isHomeBak === '1';
        this.canUsePortal = userData?.queryUserPageInfoResDTO?.status === 2;
      });
      
    });
  }
  handleImageLoad(item: any){
    this.carouselImageWH = this.carouselImageStyle();
  }

  carouselImageStyle(){
    const screenWidth = document.documentElement.clientWidth;
    const height = screenWidth / 1920 * 720
    return {
      width: `100%`,
      height: `${height}px`
    }
  }
  getList() {
    // this.isSpinning = true;
    const { title, status } = this.params; //salesOrg
    this.loginService.getBannerTableList({
      size: this.pagination.pageSize,
      current: this.pagination.pageIndex,
      title,
      status: 1,
      isAdmin: false
    }).subscribe(result => {
      const { rtnCode, rtnData } = result;
      if (rtnCode === 10000 && rtnData) {
        const { total, records } = rtnData;
        this.carouselList = records || [];
        this.carouselList.forEach(row => {
          row.imageBase64 = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpeg;base64,' + row.imageBase64);
          row.loaded = false;
        });
        this.pagination.total = total;
      }
    });
  }
  
}
